var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160135",
    "data-name": "Group 160135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.727,
    height: 21.693,
    viewBox: "0 0 31.727 21.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147607",
    "data-name": "Rectangle 147607",
    width: 31.727,
    height: 21.693,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160134",
    "data-name": "Group 160134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160133",
    "data-name": "Group 160133",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147606",
    "data-name": "Rectangle 147606",
    width: 31.001,
    height: 20.859,
    transform: "translate(0.363 0.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160136",
    "data-name": "Group 160136",
    transform: "translate(0.309 -0.119)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147608",
    "data-name": "Rectangle 147608",
    width: 10,
    height: 6.227,
    transform: "translate(4.109 3.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147609",
    "data-name": "Rectangle 147609",
    width: 10,
    height: 6.226,
    transform: "translate(17 3.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147610",
    "data-name": "Rectangle 147610",
    width: 10,
    height: 6.226,
    transform: "translate(4.109 12.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147611",
    "data-name": "Rectangle 147611",
    width: 10,
    height: 6.226,
    transform: "translate(17 12.137)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaic);
export default __webpack_public_path__ + "static/media/Mosaic.bbeabfb7f8c7452033bf10f32f1cabaa.svg";
export { ForwardRef as ReactComponent };